import React, { useEffect, useState } from 'react';
import Loader from "../../../components/Loader";
import Paginator from "../../../components/Paginator";
import ApiService from "../../../services/ApiService";
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { Link, useParams } from 'react-router-dom';
import DateRangePicker from "../../../components/DateRangePicker";
import { formatDate } from "../../../utils/helper";


const List = () => {

    const [isLoader, setIsLoader] = useState(false);
    const [currency] = useState(process.env.REACT_APP_CURRENCY);
    const [banners, setBanners] = useState([]);
    const [pagination, setPagination] = useState({});
    const [tab, setTab] = useState("home");
    
    const [apiData, setApiData] = useState({
        search: "",
        daterange: "",
        page: 1,
        type:tab
    });


    useEffect(() => {
        getBanners();
    }, [apiData.page, apiData.search, apiData.daterange,tab]); // Dependency array for re-fetching data

    const getBanners = async () => {
        try {
            setIsLoader(true);
            const response = await ApiService.request({
                method: "GET",
                url: "admin/banners",
                data: apiData
            });
            const data = response.data;
            if (data.status) {
                setBanners(data.data);
                setPagination(data.pagination);
            } else {
                toast.error(data.message);
            }
            setIsLoader(false);
        } catch (error) {
            setIsLoader(false);
        }

    };

    const handlePageChange = (event) => {
        setApiData(prev => ({ ...prev, page: event }));
    };

    const clearFilter = () => {
        setApiData({
            search: '',
            daterange: '',
            page: 1,
            tab:'home'
        });
    };

    const delData = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'you will not be able to revert it!',
            image: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonColor: '#9E9B9B',
            cancelButtonText: 'No',
        });

        if (result.isConfirmed) {
            const response = await ApiService.request({
                method: "DELETE",
                url: `admin/banners/${id}`,
            });
            const data = response.data;
            if (data.status) {
                getBanners();
                toast.success(data.message);
            } else {
                toast.error(data.message);
            }
        }
    };



    const updateStatus = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "you want to change its status!",
            image: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#4BC95F',
            confirmButtonText: 'Yes',
            cancelButtonColor: '#9E9B9B',
            cancelButtonText: 'No',
        });

        if (result.isConfirmed) {
            const response = await ApiService.request({
                method: "POST",
                url: `admin/banners/status/${id}`,
            });
            const data = response.data;
            if (data.status) {
                getBanners();
                toast.success(data.message);
            } else {
                toast.error(data.message);
            }
        }
    };

    return (
        <div className="d-flex flex-column flex-column-fluid">
            <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
                    <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0 text-capitalize">
                            {("Banners")}</h1>
                        <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                            <li className="breadcrumb-item text-muted">
                                <Link to="/admin/dashboard" className="text-muted text-hover-primary">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <span className="bullet bg-gray-400 w-5px h-2px"></span>
                            </li>
                            <li className="breadcrumb-item text-muted">{("Banners")}</li>
                        </ul>
                    </div>
                    <div className="d-flex align-banners-center gap-2 gap-lg-3">
                        {/* Add New banners Button */}
                        <Link to={`/admin/banners/create`} className='btn btn-base btn-sm'>{("Add New Banner")}</Link>
                    </div>
                </div>
            </div>
            <div id="kt_app_content" className="app-content flex-column-fluid">
                <div id="kt_app_content_container" className="app-container container-xxl">
                    <div className="card">
                        <nav>
                            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                                <button className={`nav-link fs-lg-5 ${tab === "home" ? "active" : ""}`}
                                    onClick={() => {
                                        setTab("home");
                                        setApiData(prevData => ({
                                          ...prevData,
                                          type: "home"
                                        }));
                                      }} id="nav-profile-tab" type="button"
                                    ><i class="bi bi-house-door-fill"></i> Home Banners
                                </button>
                            </div>
                        </nav>

                        <div className="card-header border-0 pt-6">
                            <div className="w-100">
                                <form method="get">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="d-flex align-banners-center position-relative my-1">
                                                <input type="text" value={apiData.search} onChange={e => setApiData({ ...apiData, search: e.target.value })} className="form-control form-control-solid me-5"
                                                    placeholder={("Search Banner title..")} />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <DateRangePicker
                                                value={apiData.daterange}
                                                onChange={(daterange) => setApiData({ ...apiData, daterange, page: 1 })}
                                                placeholder="Select Date Range"
                                            />
                                        </div>
                                        <div className="col-md-3 mt-2">
                                            <button type="button" onClick={clearFilter} className={`btn btn-sm btn-secondary mx-1 ${!apiData.search && !apiData.daterange ? 'd-none' : ''}`}>{("clear")}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="card-body pt-0">
                            <div id="kt_banners_table_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                                <div className="table-responsive">
                                    <table className="table align-middle table-hover fs-6 gy-5 dataTable no-footer">
                                        <thead>
                                            <tr className="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                                <th>Image</th>
                                                <th>Title</th>
                                                <th>Title Arabic</th>
                                                <th>Link</th>
                                                <th>Created Date</th>
                                                <th>Status</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody className="fw-semibold text-gray-600 fs-6">
                                            {banners.length > 0 ? banners.map((cat, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <img src={cat.image} alt="image" className="w-50px h-50px object-cover" />
                                                    </td>
                                                    <td>{cat.title}</td>
                                                    <td>{cat.title_ar}</td>
                                                    <td>{cat.link_to}</td>
                                                    <td> {formatDate(cat.createdAt, 'DD MMM YYYY, hh:mm A')} </td>
                                                    <td>
                                                        <button className="p-0 btn btn-transparent">
                                                            <span className={`badge ${cat.status ? 'badge-light-success' : 'badge-light-danger'}`} onClick={() => updateStatus(cat._id)} >
                                                                {cat.status ? 'Active' : 'Inactive'}
                                                            </span>
                                                        </button>
                                                    </td>
                                                    <td className="mt-2">
                                                        <Link to={`/admin/banners/create/${cat._id}`} className="btn btn-sm h-30px btn-light-primary">
                                                            <i className="bi bi-pencil-fill fs-6"></i>
                                                        </Link>
                                                        <button onClick={() => delData(cat._id)} className="btn btn-sm h-30px btn-light-primary">
                                                            <i className="bi bi-trash-fill fs-6"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            )) : (
                                                <tr>
                                                    <td colSpan="11" className="text-dark text-center mt-2"> No data found!!</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                    {isLoader && (
                                        <Loader text="Loading" size="30" className="text-center" />
                                    )}
                                    <span>Total Records: {pagination?.total_records}</span>


                                    {pagination.total_pages > 1 && (
                                        <Paginator
                                            page={pagination.current_page}
                                            rows={pagination.per_page}
                                            totalRecords={pagination.total_records}
                                            onPageChange={handlePageChange}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default List;
